<template>
  <div>
    <Modal v-model="targetModal" :title="$t('Batch')" width="80%"
      ><!-- 批量设置绩效目标 -->
      <Table
        highlight-row
        border
        :loading="loading"
        :columns="modalcolumns"
        :data="modelData"
        ref="Table1"
        id="Table1"
      ></Table>
      <Table
        highlight-row
        border
        :columns="modalcolumns"
        :data="modelDataA"
        ref="Table2"
        id="Table2"
        v-show="false"
      ></Table>
      <div style="display: flex;justify-content: flex-end;margin: 30px 0;">
        <Button @click="exportData" :loading="loading"
          ><!-- 下载模板 -->{{ $t("DownLoad_Formwork") }}</Button
        >
        <Button style="margin-left:15px" @click="handelFile"
          ><!-- 导入 -->{{ $t("import_Ach") }}</Button
        >
        <input
          type="file"
          ref="uploadExcel"
          accept=".xlsx,.xls"
          id="excel-file1"
          @change="importExcel"
          v-show="false"
        />
        <!-- <div style="display:flex;margin-top:0px">
                    <Upload :action="action" ref="my-upload" :on-success="uploadSuccess" :show-upload-list="false">
                        <Button icon="ios-cloud-upload-outline">上传</Button>
                    </Upload>
                    <span style="margin-left:20px">{{ filename }}</span>
                    </div> -->
      </div>
      <div slot="footer">
        <Button @click="targetModal = false"
          ><!-- 取消 -->{{ $t("Cancel") }}</Button
        >
        <Button @click="save" :loading="loading"
          ><!-- 保存 -->{{ $t("Save") }}</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      targetModal: false,
      modelData: [],
      modelDataA: [],
      loading: false
    };
  },
  computed: {
    modalcolumns() {
      return [
        {
          title: this.$t("Year") /* 年度 */,
          key: "year",
          align: "center",
          minWidth: 80
        },
        {
          title: this.$t("Employee_Code") /* 员工工号 */,
          key: "empCode",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Name") /* 姓名 */,
          key: "userName",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("BU") /* 业务单元 */,
          key: "businessUnit",
          align: "center",
          minWidth: 140
        },
        {
          title: this.$t("Department") /* 部门 */,
          key: "department",
          align: "center",
          minWidth: 140
        },
        {
          title: this.$t("Funciton") /* 职能 */,
          key: "postFun",
          align: "center",
          minWidth: 140
        },
        {
          title: this.$t("Performance_Priorities_Crux") /* 关键绩效指标 */,
          key: "performancePriorities",
          align: "center",
          minWidth: 140
        },
        {
          title: this.$t("Weight") /* 权重 */,
          key: "weight",
          align: "center",
          minWidth: 140
        },
        {
          title: this.$t("longText25") /* 详细描述(符合SMART原则) */,
          key: "details",
          align: "center",
          minWidth: 250
        },
        {
          title: this.$t("Detailed_Measures_1") /* 衡量指标1 */,
          key: "measureTarget1",
          align: "center",
          minWidth: 140
        },
        {
          title: this.$t("Detailed_Measures_2") /* 衡量指标2 */,
          key: "measureTarget2",
          align: "center",
          minWidth: 140
        },
        {
          title: this.$t("Detailed_Measures_3") /* 衡量指标3 */,
          key: "measureTarget3",
          align: "center",
          minWidth: 140
        },
        {
          title: this.$t("Detailed_Measures_4") /* 衡量指标4 */,
          key: "measureTarget4",
          align: "center",
          minWidth: 140
        },
        {
          title: this.$t("Detailed_Measures_5") /* 衡量指标5 */,
          key: "measureTarget5",
          align: "center",
          minWidth: 140
        }
        // {
        //     title: "关联目标类型",
        //     key:'relevanceTargetType',
        //     align: "center",
        //     minWidth: 130
        // }
      ];
    }
  },
  methods: {
    save() {
      this.$Modal.confirm({
        title: this.$t("BatchAchForm"),
        onOk: () => {
          const array = [];
          this.modelData.forEach(element => {
            const list = [];
            for (var i = 0; i < 5; i++) {
              list.push({
                ...element,
                measure: element[`measureTarget${i + 1}`]
              });
            }
            array.push({
              achTargetInfo: element,
              achTargetImportList: list
            });
          });
          this.loading = true;
          axios.post("/achTargetSetting/startAchApply", array).then(res => {
            if (res) {
              this.$Message.success("导入成功");
            }
            this.loading = false;
          });
        }
      });
    },
    handelFile() {
      this.$refs.uploadExcel.click();
    },
    getData() {
      this.loading = true;
      axios.post("/achTargetSetting/selectLoginAllEmp", {}).then(res => {
        if (res) {
          this.modelDataA = res;

          this.$nextTick(() => {
            this.loading = false;
            this.$exportExcel(
              "Table2",
              "绩效目标" + this.$nowDate.dateVal(new Date(), "YYYY-MM-DD HH-mm")
            );
          });
        }
      });
    },
    importExcel(e) {
      var file_name = document.getElementById("excel-file1").value;
      console.log(file_name);
      file_name = file_name.substring(file_name.lastIndexOf(".")).toLowerCase();
      var uploadFormat = [".xlsx", ".xls"];

      if (file_name != uploadFormat[0] && file_name != uploadFormat[1]) {
        this.$Message.warning({
          content:
            "文件类型不正确, 请选择" + uploadFormat.join(" or ") + "类型",
          duration: 5
        });
        return;
      }

      this.$importExcel("excel-file1", e, "Table1", data => {
        // this.data = this.data.concat(data)
        console.log(data);
        data.forEach(async element => {
          let wei = "";
          if (element.weight != undefined || element.weight) {
            wei = element.weight.toString();
          } else {
            wei = element.weight;
          }

          if (wei != undefined && wei.includes(".")) {
            // let reg=new RegExp('%','')

            // let str=wei.replace(reg,"")
            // element.weight=str
            element.weight = Number(wei) * 100;
          }
          element.businessUnit = this.businessUnitList
            .filter(
              item =>
                element.businessUnitVal == item.code ||
                element.businessUnitVal == item.ch_value ||
                element.businessUnitVal == item.en_value
            )
            .map(res => res.code)[0];
          element.department = this.departmentList
            .filter(
              item =>
                element.departmentVal == item.code ||
                element.departmentVal == item.ch_value ||
                element.departmentVal == item.en_value
            )
            .map(res => res.code)[0];
          element.postFun = this.funcationList
            .filter(
              item =>
                element.postFunVal == item.code ||
                element.postFunVal == item.ch_value ||
                element.postFunVal == item.en_value
            )
            .map(res => res.code)[0];
          if (
            !element.businessUnit ||
            !element.department ||
            !element.postFun
          ) {
            element.flag = "1";
            // this.$Message.error('导入内容有误,需请从页面从新选择')
          }
          const list = [];
          for (var i = 0; i < 5; i++) {
            list.push({
              ...element,
              measure: element[`measureTarget${i + 1}`]
            });
          }
          array.push({
            achTargetInfo: element,
            achTargetImportList: list
          });
        });
        this.modelData = data;

        // axios.post("/achTargetSetting/reportAchTargetInfoList", array).then((res) => {
        //     if (res) {
        //         this.$Message.success('导入成功');
        //         this.getData()
        //     }
        // });
      });
    },
    exportData() {
      this.getData();

      // this.$refs.Table1.exportCsv({
      //     filename: '绩效目标',
      //     data: []
      // });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/AchTargetSettingComponents/BatchModal.vue